import { useQuery } from 'react-query'
import { get, Params } from 'api/fetch'
import { SupplyRequestReviewStatus } from 'backoffice/components/GpsPetitions/types/types'

const apiUrl = process.env.REACT_APP_API_V2 ?? ''

interface RecentGpsPetitionsResponse {
  items: Array<{
    id: string
    createdAt: string
    drop: {
      id: string
      name: string
    }
  }>
  total: number
}

const getRecentPendingGpsPetitions = async (): Promise<RecentGpsPetitionsResponse> => {
  const twentyFourHoursAgo = new Date()
  twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - 24)

  const params: Params = {
    status: SupplyRequestReviewStatus.PENDING,
    limit: '100',
    offset: '0',
  }

  const res = await get(`${apiUrl}/drop-requests/gps`, params)

  if (res.status === 200 && res.parsedBody) {
    const responseData = res.parsedBody as {
      items: Array<{
        id: string
        createdAt: string
        drop: {
          id: string
          name: string
        }
      }>
      total: number
    }

    const { items } = responseData

    const filteredItems = items
      .filter((item) => {
        const createdAt = new Date(item.createdAt)
        return createdAt >= twentyFourHoursAgo
      })
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map((item) => ({
        id: item.id,
        createdAt: item.createdAt,
        drop: {
          id: item.drop.id,
          name: item.drop.name,
        },
      }))

    return {
      items: filteredItems,
      total: filteredItems.length,
    }
  }

  throw new Error('Failed to fetch recent GPS petitions')
}

export const useRecentGpsPetitionsQuery = () => {
  return useQuery(['recentGpsPetitions'], getRecentPendingGpsPetitions, {
    refetchInterval: 30 * 1000,
    staleTime: 0,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  })
}
